module.exports = __webpack_public_path__ + "img/2.381ab094.png";